import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validator, Validators } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { MaskConstants, RegexConstants } from '@wz-constants';
import { TextInputComponent } from './text-input.component';

@Component({
  selector: 'wz-num-orga-affiliation-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  standalone: false,
  providers: [
    {
      provide: MatFormFieldControl,
      useExisting: NumeroOrgaAffiliationInputComponent,
    },
    {
      provide: TextInputComponent,
      useExisting: NumeroOrgaAffiliationInputComponent,
    },
  ],
})
export class NumeroOrgaAffiliationInputComponent
  extends TextInputComponent
  implements OnInit, OnDestroy, Validator
{
  override get controlType() {
    return 'wz-num-orga-affiliation-input';
  }

  override maskConfig = MaskConstants.NumeroOrgaAffiliationConfig;

  override ngOnInit() {
    super.ngOnInit();
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
  }

  validate(fc: FormControl) {
    let validatorFn = Validators.pattern(RegexConstants.NumeroOrgaAffiliation);
    return validatorFn(fc);
  }
}
